var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import unifiedActivity, { INITIAL_STATE, TYPE_CATEGORIES, DEFAULT_BATCH_SIZE } from '@banking/ui/workflows/unified-activity/unified-activity';
import { tracked } from '@glimmer/tracking';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createSelect, createEmit } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import { formatActivityDetails } from '@banking/ui/utils/activity/detail/formatter';
import BalanceReporterActivity from '@banking/ui/utils/activity/balance-reporter-activity';
import { ActionCreator } from '@banking/ui/workflows/balance';
const SERVICE_REGISTRY_KEY = 'reporter';
let Reporter = (_dec = service('bbfrontend/v1/printable-check'), _dec2 = service('bbfrontend/v1/categories'), (_class = class Reporter extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "logEvents", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "balanceReporterApi", _descriptor6, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor7, this);
    _initializerDefineProperty(this, "transactionServiceApi", _descriptor8, this);
    _initializerDefineProperty(this, "unitBalance", _descriptor9, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor10, this);
    _initializerDefineProperty(this, "dataApi", _descriptor11, this);
    _initializerDefineProperty(this, "bbFrontendV1PrintableCheckService", _descriptor12, this);
    _initializerDefineProperty(this, "bbFrontendV1CategoriesService", _descriptor13, this);
    _initializerDefineProperty(this, "state", _descriptor14, this);
    _defineProperty(this, "states", void 0);
    _defineProperty(this, "emit", void 0);
    _defineProperty(this, "updates", void 0);
    const activitiesApi = new BalanceReporterActivity(this.balanceReporterApi, detail => formatActivityDetails(detail, this.intl, this.sentry), this.features);
    const {
      emit,
      states,
      updates
    } = unifiedActivity({
      cancelPrintableCheck: this.bbFrontendV1PrintableCheckService.client.cancelPrintableCheck.bind(this.bbFrontendV1PrintableCheckService.client),
      dataApi: this.dataApi,
      dismissPrintableCheckBlade: () => {
        this.unitBalance.emit(ActionCreator.userClickDismissPrintableCheckBlade());
      },
      downloadCheck: printableCheckId => {
        this.unitBalance.emit(ActionCreator.userClickDownloadCheck(printableCheckId));
      },
      getBootstrapPrintableCheckManagement: this.bbFrontendV1PrintableCheckService.client.bootstrapPrintableCheckManagement.bind(this.bbFrontendV1PrintableCheckService.client),
      getActivities: activitiesApi.getActivities.bind(activitiesApi),
      getActivityDetails: activitiesApi.getActivityDetails.bind(activitiesApi),
      listCategories: this.bbFrontendV1CategoriesService.client.listCategories.bind(this.bbFrontendV1CategoriesService.client),
      logEvents: this.logEvents,
      marketToasts: this.marketToasts,
      printCheck: printableCheckId => {
        this.unitBalance.emit(ActionCreator.userClickPrintCheck(printableCheckId));
      },
      recognizeTransaction: this.transactionServiceApi.overrideDeclinedAuth.bind(this.transactionServiceApi),
      retrieveTransactionAuth: this.transactionServiceApi.retrieveAuthState.bind(this.transactionServiceApi),
      sentry: this.sentry,
      updateCategory: this.bbFrontendV1CategoriesService.client.updateCategory.bind(this.bbFrontendV1CategoriesService.client),
      translate: key => this.intl.t(key)
    }, {
      config: {
        requireExportLink: true,
        enablePostedBalance: true,
        typeCategories: TYPE_CATEGORIES,
        activityPageSize: DEFAULT_BATCH_SIZE
      }
    });
    this.emit = emit;
    this.states = states;
    this.updates = updates;
    states.subscribe(state => {
      this.state = state;
    });
    updates.subscribe(updateLogger('Unified Activity'));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "balanceReporterApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "transactionServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "unitBalance", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1PrintableCheckService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CategoriesService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL_STATE;
  }
})), _class));
export { Reporter as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);